import React from 'react'

export const OpenWorld = () => {
  return (
    <div>
      <p>Open World</p>
      <h2>soon...</h2>
    </div>
  )
}
